import React from 'react'
import { Link } from 'react-router-dom'

const navigations=[
  {
   name:'Home',
  icon:<i class="bi bi-house"></i>,
  path:'/'
},
{
   name:'Products',
   icon:<i class="bi bi-boxes"></i>,
  path:'/products'
},
{
  name:'Contact Us',
  icon:<i class="bi bi-telephone-forward"></i>,
  path:'/contact'
}


]



const Header = () => {
  return (
    <header className="text-gray-600 body-font shadow-lg">
    <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
      <Link to={`/`} className="  cursor-pointer flex title-font font-medium items-center text-gray-900 mb-4 md:mb-0">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-10 h-10 text-white p-2 bg-red-500 rounded-full" viewBox="0 0 24 24">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
        </svg>
        <span className="ml-3 text-4xl">E-Shop</span>
      </Link>
      <nav className="md:ml-auto md:mr-auto flex flex-wrap items-center text-base justify-center">

        {
          navigations.map((navigation)=>{
            return(
              
              <Link to={navigation.path}className="mr-5 cursor-pointer  text-3xl text-black hover:text-indigo-900">{navigation.icon}{navigation.name}</Link>
          
              
            )
          })
        }
      </nav>
      <Link to={'/cart'} className="  inline-flex items-center text-white bg-indigo-500 border-0 py-2 px-4 focus:outline-none hover:bg-indigo-800 rounded text-2xl  mt-2 md:mt-0">Go to Cart
        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" className="w-4 h-4 ml-1" viewBox="0 0 24 24">
          <path d="M5 12h14M12 5l7 7-7 7"></path>
        </svg>
      </Link>
    </div>
  </header>
  )
}

export default Header
